// extracted by mini-css-extract-plugin
export default {"confirmButton":"confirmButton--yTkwy","horizontalSelectRoot":"horizontalSelectRoot--yTkwy","inlineSelectRoot":"inlineSelectRoot--yTkwy"};